const houseRouter = [
  {
    path: '/openInvitation',
    name: 'openInvitation',
    component: () => import('@/views/house-customer/new-house-customer/openInvitationTwo'),
    meta: {
      title: '勘测邀请'
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/house-customer/new-house-customer/reportTwo'),
    meta: {
      title: '勘测报告'
    }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/views/house-customer/new-house-customer/successScore'),
    meta: {
      title: '勘测评价'
    }
  },
  {
    path: '/invitationInfo',
    name: 'invitationInfo',
    component: () => import('@/views/house-customer/new-house-customer/invitationInfoTwo'),
    meta: {
      title: '勘测邀请'
    }
  },
  {
    path: '/reportInfo',
    name: 'reportInfo',
    component: () => import('@/views/house-customer/new-house-customer/reportInfoTwo'),
    meta: {
      title: '勘测报告'
    }
  },
  {
    path: '/score',
    name: 'score',
    component: () => import('@/views/house-customer/new-house-customer/scoreTwo'),
    meta: {
      title: '勘测评价'
    }
  },
  {
    path: '/bookCreate',
    name: 'comment',
    component: () => import('@/views/house-staff/create'),
    meta: {
      title: '勘测报告'
    }
  },
  {
    path: '/success2',
    name: 'success2',
    component: () => import('@/views/house-customer/new-house-customer/successInvitation'),
    meta: {
      title: '勘测邀请'
    }
  }
]
export default houseRouter
